// extracted by mini-css-extract-plugin
module.exports = {"label":"Scorecard_label__18pS7"};